import store from '../store'

const constantRoutes = [
  // {
  //   name: 'ConfirmInformationPopup',
  //   path: 'confirmInformationPopup',
  //   component: resolve => require(['../pages/constant/confirmInformationPopup'], resolve)
  // },
  {
    name: 'Home',
    path: 'home',
    component: resolve => require(['../pages/constant/home'], resolve)
  }
]

// 加载loading
let loadingDom = null
let loadingDomChild = null

function startLoading () {
  loadingDom = document.createElement('div')
  loadingDomChild = document.createElement('div')
  loadingDomChild.setAttribute('class', 'custom-loading-child')
  loadingDom.setAttribute('class', 'custom-loading')
  loadingDom.appendChild(loadingDomChild)
  document.body.style.position = 'relative'
  document.body.appendChild(loadingDom)
}

function closeLoading () {
  document.body.removeChild(loadingDom)
  document.body.style.position = ''
}

// 将列表转换成树结构所需数据
function listToTree (list, parentId) {
  return list.filter(item => (parentId ? item.parentId === parentId : !item.parentId) && item.isShow).sort((a, b) => a.sort - b.sort).map(item => {
    let resItem = {...item}
    // 去掉动态路由(path/:xx)中的动态路由传参(/:xx)后的path
    resItem.purePath = item.path.includes('/:') ? item.path.split('/:')[0] : item.path
    let children = listToTree(list, item.id)
    if (children.length) {
      resItem.children = children
    }
    return resItem
  })
}
// 获取路由表数据
function getRoutes (menus) {
  let resRoutes = []
  if (menus && menus.length) {
    menus.forEach(menu => {
      let route = {
        path: menu.path,
        name: menu.path.slice(0, 1).toUpperCase() + menu.path.slice(1),
        props: true,
        component: resolve => require([`../pages/async/${menu.templatePath}`], resolve),
        meta: {
          purePath: menu.purePath,
          name: menu.name
        }
      }
      let children = menu.children
      if (children && children.length) {
        route.children = getRoutes(children)
      }
      resRoutes.push(route)
    })
  }
  return resRoutes
}

// 获取完整的动态路由表信息
function getAsyncRouters (menuList) {
  let routerTreeData = listToTree(menuList)
  // 存到vuex
  store.dispatch('initAuthorityMenus', routerTreeData)
  return [
    {
      path: '',
      component: resolve => require(['../pages/index'], resolve),
      redirect: '/home',
      children: [
        ...constantRoutes,
        {
          name: 'Async',
          path: '/async',
          component: resolve => require(['../pages/async'], resolve),
          children: getRoutes(routerTreeData)
        }
      ]
    }
  ]
}

function judgeIsThisPath (menuObj, purePath) {
  return menuObj.purePath === purePath
}

function getCompletePath (purePath, prevPath = '/async', authorityMenus = store.state.authorityMenus.authorityMenus || []) {
  for (let i = 0; i < authorityMenus.length; i++) {
    let authorityMenu = authorityMenus[i]
    if (judgeIsThisPath(authorityMenu, purePath)) {
      return prevPath + '/' + authorityMenu.purePath
    } else if (authorityMenu.children && authorityMenu.children.length) {
      let completePath = getCompletePath(purePath, prevPath + '/' + authorityMenu.path, authorityMenu.children)
      if (completePath) {
        return completePath
      }
    }
  }
}

function checkTopMenu (purePath, authorityMenu) {
  if (authorityMenu.purePath === purePath) {
    return true
  } else {
    let children = authorityMenu.children
    if (children && children.length) {
      for (let i = 0; i < children.length; i++) {
        let child = children[i]
        let flag = checkTopMenu(purePath, child)
        if (flag) {
          return flag
        }
      }
    }
  }
  return false
}

export {
  startLoading,
  closeLoading,
  getAsyncRouters,
  getCompletePath,
  checkTopMenu
}
